import * as React from "react";
import { Spinner } from "@fluentui/react";

const version = process.env.APP_VERSION;

const semverGreaterThan = (versionA: string, versionB: string) => {
    const versionsA = versionA.split(/\./g);

    const versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
        const a = Number(versionsA.shift());

        const b = Number(versionsB.shift());
        // eslint-disable-next-line no-continue
        if (a === b) continue;
        // eslint-disable-next-line no-restricted-globals
        return a > b || isNaN(b);
    }
    return false;
};

const refreshCacheAndReload = () => {
    console.log('Clearing cache and hard reloading...')
    if (caches) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then(function (names) {
            for (let name of names) caches.delete(name);
        });
    }
    // delete browser cache and hard reload
    window.location.reload(true);
}

interface ICacheBusterState {
    loading: boolean;
    isLatestVersion: boolean;
}

export default class CacheBuster extends React.Component<{},ICacheBusterState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            loading: true,
            isLatestVersion: false
        }
    }

    public componentDidMount() {
        fetch('/meta.json')
            .then((r) => r.json())
            .then((meta) => {
                const latestVersion = meta.version;

                const shouldForceRefresh = semverGreaterThan(latestVersion, version as string);
                if (shouldForceRefresh) {
                    console.log(`We have a new version - ${latestVersion}. Should force refresh`);
                    this.setState({ loading: false, isLatestVersion: false });
                } else {
                    console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);
                    this.setState({ loading: false, isLatestVersion: true });
                }
            });
    }

    public componentDidUpdate(prevProps: any, prevState: ICacheBusterState) {
        if (prevState.loading && !this.state.loading && !this.state.isLatestVersion) {
            refreshCacheAndReload();
        }
    }

    public render() {
        const { loading } = this.state;
        if (loading) {
            return <Spinner />
        }
        return this.props.children;
    }
}